import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { IconInfoFilled } from 'svgIcons/MotionPortalIcons';
import colors from 'theme/_colors.scss';
import './style.scss';
import { updateFirmware } from './actions';

const UpdateFirmwareComponent = ({ show, close, gatewayID }) => {
    const { t: translate } = useTranslation();
    const dispatch = useDispatch();

    const content = <div className='update-firmware__content'>
        <p className='update-firmware__content-text'>{translate('ABB.Powertrain.Frontend.gatewayUpdateFirmwareDescription')}</p>
    </div>;

    const getUpdateFirmwareTitle = <h1 className='update-firmware__title'>
        <IconInfoFilled color={colors.primaryInfo} />
        <span className='update-firmware__title-text'>{translate('ABB.Powertrain.Frontend.gatewayUpdateFirmwareTitle')}</span>
    </h1>;
    return <GeneralDialog
        show={show}
        close={close}
        title={getUpdateFirmwareTitle}
        id='update-firmware-dialog'
        dialogClassName='update-firmware__dialog'
        closeButton={true}
        cancelButtonProps={{
            text: translate('ABB.Powertrain.Frontend.cancelLabel'),
        }}
        acceptButtonProps={{
            text: translate('ABB.Powertrain.Frontend.gatewayUpdateFirmwareButtonLabel'),
            onClick: () => {
                dispatch(updateFirmware(gatewayID));
                close();
            }
        }}
    >
        {content}
    </GeneralDialog>;
};

UpdateFirmwareComponent.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    gatewayID: PropTypes.string,
};

export default UpdateFirmwareComponent;
